import type { PropsWithChildren } from 'react';

import { IpLimitsVerification } from './IpLimitsVerification';
import { InvitePersistedDataVerification } from './PersistedDataVerification';

export const InviteSignUpGuard = ({ children }: PropsWithChildren) => {
  return (
    <IpLimitsVerification>
      <InvitePersistedDataVerification>{children}</InvitePersistedDataVerification>
    </IpLimitsVerification>
  );
};
